<template>
  <section class="body-sign">
    <div class="center-sign">
      <div class="panel card-sign">
        <div class="card-title-sign mt-3 text-end d-flex justify-content-between">
          <img src="logo_login.png" height="70" alt="Porto Admin" />
          <h2 class="title text-uppercase font-weight-bold m-0">
            <i class="bx bx-user-circle me-1 text-6 position-relative top-5"></i>
            Recover  Password
          </h2>
        </div>
        <div class="card-body">
          <div class="alert alert-info">
            <p class="m-0">
              Enter your e-mail below and we will send you reset instructions!
            </p>
          </div>

          <form>
            <div class="form-group mb-0">
              <div class="input-group">
                <input
                  name="username"
                  type="email"
                  placeholder="E-mail"
                  class="form-control form-control-lg"
                />
                <button class="btn btn-primary btn-lg" type="submit">
                  Reset!
                </button>
              </div>
            </div>

            <p class="text-center mt-3">
              Remembered?
              <router-link exact :to="{ name: 'Login' }">
                Sign In!
              </router-link>
            </p>
          </form>
        </div>
      </div>

      <p class="text-center text-muted mt-3 mb-3">
        © Copyright 2023. Sva prava zadržana.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ForgotPassword'
};
</script>